import React from 'react';

class ErrorHandler extends React.Component {
    constructor() {
        super();
        this.state = { hasError: false };
    }

    componentDidCatch(error, info) {
        this.setState({ hasError: true });
    }

    render() {
        if (this.state.hasError) {
            return <h1>Ohh, something went wrong.</h1>;
        }
        return this.props.children;
    }
}

export default ErrorHandler;


// WEBPACK FOOTER //
// ./src/components/ErrorHandler.js